import { computed, ref, shallowRef } from 'vue';
import { defineStore } from 'pinia';
import { retrieveCoverLetters , deleteCoverLetters } from '../api/cover-letters';

export const useCoverLettersStore = defineStore('cover-letters', () => {
	const coverLetters = ref([]);
    
	const loading = shallowRef(false);
	const deleteLoading = shallowRef(false);
	const loaded = shallowRef(false);

	const fetchCoverLetters = () => {
		loading.value = true;
        
		retrieveCoverLetters().then((res) => {
			coverLetters.value = res;
			loaded.value =  true;
			loading.value = false;
		});
	};
        
	const autocompleteCoverLetter = computed(() => 
		coverLetters.value.map((coverLetter) => ({
			id: coverLetter?.uuid,
			label: coverLetter?.title?.replace(/<[^>]*>/g, '') ?? 'Untitled',
		}))
	);
    
	const deleteCoverLetter = async (coverLetterId) => {
		deleteLoading.value = true;
        
		await deleteCoverLetters(coverLetterId);

		const deletedCoverLetterIndex = coverLetters.value.findIndex((cl) => cl.uuid === coverLetterId);
		coverLetters.value.splice(deletedCoverLetterIndex, 1);
        
		deleteLoading.value = false;
	};
  
	return {
		autocompleteCoverLetter,
		coverLetters,
		loading,
		loaded,

		fetchCoverLetters,
		deleteCoverLetter
	};
});
